module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c08"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('strong', [_vm._v("c. 525 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("No-Self "), _c('em', [_vm._v("(Anatta)")])]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Siddhārtha Gautama (Buddha)")]), _vm._v(" (c. 560–c. 380 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In Buddha’s time, like today, Hinduism was the major religion of India. Buddha agreed with some Hindu teachings, including the doctrines of karma and reincarnation, but rejected others. Among these was the Hindu idea, found in the Upanishads, of a permanent soul or self (Ātman) that is ultimately identical with the absolute Reality (Brahman). By contrast, Buddha taught that there is no soul or self in the sense of a self-identical ego, a substance that endures over time. This idea of no-self ("), _c('em', [_vm._v("anatta")]), _vm._v(") is a central teaching of Buddhism, one of the three so-called “marks of existence,” or dharma seals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buddha believed that what people call a soul or self is really only a temporary bundle or aggregation of mental and physical features ("), _c('em', [_vm._v("skandhas")]), _vm._v("). These include body, perception, feelings, consciousness, and instincts or predispositions (some of which are subconscious). These five constantly changing features more or less hang together as an integrated unit while we are alive, but they do not constitute a “thing” or an “entity,” and at death they dissolve or disperse. There is no soul, or “me,” that survives death. This raises an obvious problem for Buddha’s belief in karma and reincarnation. For if there is no enduring soul or self, what is it that gets reincarnated into another form and is the bearer of karma? Buddha’s answer was that a kind of karma-laden psychic structure carries over into the next life, yet this is not a soul or self but simply an information-bearing packet of habits, predispositions, and so forth that survives death and forms the basis for a person’s next incarnation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buddha’s denial of a permanent self is related to another key teaching of Buddhism: impermanence ("), _c('em', [_vm._v("anicca")]), _vm._v("). Buddha taught that reality is an ever-changing phantasmagoria, a flux in which nothing is permanent. Everything is constantly changing, so that nothing remains literally “itself” or “the same” from one moment to the next. This is part of why Buddha denied the existence of a permanent self. As he saw it, change is such a fundamental feature of empirical reality that each of us is literally a different person each second of our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img27"
    }
  }, [_c('em', [_vm._v("In Tibetan Buddhism, the concept of impermanence—a key teaching of Buddhism—is symbolized by sand mandalas: complex, sacred diagrams symbolizing the cosmos. They are painstakingly created by monks with grains of colored sand, and then ceremonially disassembled and poured into nearby bodies of water to carry their blessings.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/27-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c01"
    }
  }, [_vm._v("The Vedas (c. 1500 BCE)")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c07"
    }
  }, [_vm._v("The Four Noble Truths (c. 525 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c119",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Treatise of Human Nature")]), _vm._v(" (1739)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c35a07e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c08.vue
// module id = 96
// module chunks = 0